import React, {useState} from 'react';

import {USER_ROLES} from '../../../../../website-ui/constants/user';
import {useUser} from '../../../../../website-ui/hooks/use-user';

import {StepNickname} from './components/step-nickname';
import {StepNoNickname} from './components/step-no-nickname';
import {StepNoPhone} from './components/step-no-phone';
import {StepPhone} from './components/step-phone';
import {WIDGET_GROUP_B_STEPS} from './constants';

import styles from './authenticated-overlay.module.css';

const AuthenticatedOverlay = () => {
  const user = useUser();

  const hasPhoneNumber = user.role === USER_ROLES.EXTENDED;
  const hasNickname = Boolean(user.username);

  const getInitialStep = () => {
    if (!hasPhoneNumber) {
      return WIDGET_GROUP_B_STEPS.NO_PHONE;
    }
    if (!hasNickname) {
      return WIDGET_GROUP_B_STEPS.NO_NICKNAME;
    }
    return '';
  };

  const [currentStep, setCurrentStep] = useState(getInitialStep());

  if (hasNickname && hasPhoneNumber) {
    return null;
  }

  const handlePhoneAddSuccess = () => {
    setCurrentStep(hasNickname ? '' : WIDGET_GROUP_B_STEPS.NO_NICKNAME);
  };

  return (
    <div className={styles.root}>
      {currentStep === WIDGET_GROUP_B_STEPS.NO_PHONE && (
        <StepNoPhone goNext={() => setCurrentStep(WIDGET_GROUP_B_STEPS.PHONE)} />
      )}
      {currentStep === WIDGET_GROUP_B_STEPS.NO_NICKNAME && (
        <StepNoNickname goNext={() => setCurrentStep(WIDGET_GROUP_B_STEPS.NICKNAME)} />
      )}
      {currentStep === WIDGET_GROUP_B_STEPS.PHONE && (
        <StepPhone
          onPhoneCancelClick={() => setCurrentStep(WIDGET_GROUP_B_STEPS.NO_PHONE)}
          goNext={handlePhoneAddSuccess}
        />
      )}
      {currentStep === WIDGET_GROUP_B_STEPS.NICKNAME && (
        <StepNickname onCancelClick={() => setCurrentStep(WIDGET_GROUP_B_STEPS.NO_NICKNAME)} />
      )}
    </div>
  );
};

export {AuthenticatedOverlay};
